import { useMemo } from 'react'

import { useDataValue } from 'Simple/Data.js'

export default function useDataTransform(props, data) {
  let patient_id = useDataValue({
    viewPath: props.viewPath,
    context: 'patient',
    path: 'id',
  })
  let tooth_chart_snapshot = useDataValue({
    context: 'tooth_chart_snapshot',
    viewPath: props.viewPath,
  })
  let is_new_generate_letters_enabled = useDataValue({
    context: 'global',
    viewPath: props.viewPath,
    path: 'feature_flags.is_new_generate_letters_enabled',
  })

  return useMemo(
    () => ({
      patient_id,
      appointment_id: tooth_chart_snapshot.appointment.id,
      booking_id: tooth_chart_snapshot.appointment.booking?.id,
      snapshot_id: tooth_chart_snapshot.id,
      is_new_generate_letters_enabled,
      tab: 'appointment_tooth_chart',
    }),
    [tooth_chart_snapshot, patient_id, is_new_generate_letters_enabled]
  )
}
